import React, {Component} from "react";
import actions from '../actions';
import entityActions from '../../../baseApp/entities/actions';
import {connect} from 'react-redux';
import _ from '../../../baseApp/shared/utils/ObjectUtils';
import ConsoleUsersPage from '../components/ConsoleUsersPage';
import ObjectUtils from '../../../baseApp/shared/utils/ObjectUtils';

class ConsoleUsersPageContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            universalSearchField: "",
            defaultSort: {
                property : "lastCommunicationTimestamp",
                direction : "DESC"
            },
            searchFieldsValues: {
                username: {
                    value: ""
                },
                entityId: {
                    value: []
                },
                numberOfConnections: {
                    value: ""
                },
                active: {
                    value: ""
                },
                lastCommunication: {
                    value: ""
                },
                properties:{
                    maxNumberOfConnections: {
                        value: ""
                    }
                }
            }
        }
    }

    componentDidMount() {
        const { getEntityList} = this.props;
        getEntityList();
        this.fetchData();
    }

    fetchData = (currentPage, pageSize, sortProperty, sortDirection) => {
        let {
            searchFieldsValues,
            universalSearchField,
            defaultSort
        } = this.state;

        if(currentPage === undefined){
            if(this.props.location.state?.searchFieldsData !== undefined){
                searchFieldsValues =  this.props.location.state.searchFieldsData;
                this.handleSearchFieldValuesChange(searchFieldsValues);
            }
            if(this.props.location.state?.universalSearchField !== undefined ){
                universalSearchField = this.props.location.state.universalSearchField;
                this.handleUniversalSearchFieldChange(universalSearchField);
            }
        }

        let filter = Object.entries(searchFieldsValues).reduce((acc, [key, field]) => {
            return ObjectUtils.isNilOrEmpty(field.value) ?
                {...acc} : {...acc, [key]: field.value}
        }, {});

        if (!ObjectUtils.isNilOrEmpty(universalSearchField)) {
            filter = {
                ...filter,
                universalSearch: universalSearchField,
            }
        }
        this.props.searchConsoleUsers({
            ...filter,
            currentPage: currentPage,
            pageSize: pageSize,
            sortProperty: !_.isNilOrEmpty(sortProperty) ? sortProperty : defaultSort.property,
            sortDirection: !_.isNilOrEmpty(sortDirection) ? sortDirection : defaultSort.direction,
        });
    };

    handleSearchFieldChange = (id, value) => {
        this.setState({
            searchFieldsValues: {
                ...this.state.searchFieldsValues,
                [id]: {
                    ...this.state.searchFieldsValues[id],
                    value: value
                }
            }
        })
    };

    handleSearchFieldValuesChange = (value) => {
        this.setState({
            searchFieldsValues: value
        })
    };

    handleUniversalSearchFieldChange = (value) => {
        this.setState({
            universalSearchField: value
        })
    };

    handleSearchSubmit = () => {
        const {
            table: {
                sort,
                pageNumber: currentPage,
                pageSize,
            }
        } = this.props;
        this.fetchData(currentPage, pageSize, sort.property, sort.direction);
    };

    handleSearchClear = () => {
        const formattedData = Object.entries(this.state.searchFieldsValues).reduce((acc, [key, value]) => {
            if(key === "properties"){
                return {
                    ...acc,
                    [key]: {
                        ...Object.entries(value).reduce((propertyAcc, [propertyKey, propertyValue]) => {
                            return {
                                ...propertyAcc,
                                [propertyKey]: {
                                    value: ""
                                }
                            }
                        }, { })
                    }
                }
            } else {
                return {
                    ...acc,
                    [key]: {
                        ...acc[key],
                        value: ""
                    }
                }
            }
        }, { });
        this.setState({
            universalSearchField: "",
            searchFieldsValues: {
                ...formattedData
            }
        })
    };

    onPageChange = (currentPage) => {
        const {
            table: {
                sort,
                pageSize,
                totalPages: pages
            }
        } = this.props;

        if (currentPage >= pages || currentPage < 0) return;

        this.fetchData(currentPage, pageSize, sort.property, sort.direction);
    };

    onPageSizeChange = (itemsPerPage) => {
        const {
            table: {
                sort,
                pageNumber: currentPage
            }
        } = this.props;

        this.fetchData(currentPage, itemsPerPage, sort.property, sort.direction);
    };

    handleSortChanged = newSort => {
        const {
            table:  {
                pageNumber,
                pageSize
            }
        } = this.props;

        const sortProperty = newSort[0].id;
        const sortDirection = newSort[0].desc? 'DESC' : 'ASC';

        this.fetchData(pageNumber, pageSize, sortProperty, sortDirection);
    };

    handleAddButtonClicked = () => {
        this.props.history.push('/consoleUsers/create');
    };

    handleRowClicked = consoleUser => {
        this.props.history.push({
            pathname: '/consoleUsers/' + consoleUser.id,
            state: { searchFieldsData : this.state.searchFieldsValues, universalSearchField: this.state.universalSearchField }
        });
    };

    render() {
        const { searchFieldsValues, universalSearchField } = this.state;
        const {
            table: {
                data,
                sort,
                pageSize,
                totalPages: pages,
                pageNumber: currentPage,
                totalElements
            },
            entityList,
        } = this.props;

        return (
            <ConsoleUsersPage
                searchFieldsValues={searchFieldsValues}
                universalSearchField={universalSearchField}

                handleSearchFieldChange={this.handleSearchFieldChange}
                handleUniversalSearchFieldChange={this.handleUniversalSearchFieldChange}
                handleSearchSubmit={this.handleSearchSubmit}
                handleSearchClear={this.handleSearchClear}
                handleSortChanged={this.handleSortChanged}
                handleAddButtonClicked={this.handleAddButtonClicked}

                data={data}
                sort={sort}
                totalElements={totalElements}
                entityList={entityList}
                pages={pages}
                currentPage={currentPage}
                pageSize={pageSize}
                onRowClick={this.handleRowClicked}
                onPageChange={this.onPageChange}
                onPageSizeChange={this.onPageSizeChange}
            />
        );
    }
}

const mapStateToProps = ({ consoleUsersReducer, entitiesReducer}) => {
    return {
        searchFieldsData: consoleUsersReducer.searchFieldsData,
        table: consoleUsersReducer.table,
        entityList: entitiesReducer.entityList,
    };
};

const mapDispatchToProps = {
    searchConsoleUsers: actions.searchConsoleUsers,
    getEntityList: entityActions.getEntityList,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ConsoleUsersPageContainer);